module.exports = __webpack_public_path__ + "d1bb9c3844782af65b7c2d777c96f8da.svg";